import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { getMetaValue } from "../plugins/src/metadata"

// Controller for drag-to-reorder slides within a row
export default class extends Controller {
  static targets = ["item"]

  connect() {
    Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      handle: ".sortable-slide-handle",
      animation: 150,
      ghostClass: "opacity-50",
      chosenClass: "ring-2 ring-blue-500",
      forceFallback: true,
    });
  }

  onEnd(event) {
    const url = event.item.dataset.slideSortablesPath
    const data = {
      slide: {
        slide_order_position: event.newIndex,
      }
    }

    fetch(url, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(() => {
        // Dispatch event to refresh preview if available
        document.dispatchEvent(new CustomEvent("preview:content-changed", {
          detail: { source: "slide-reorder" }
        }))
      })
      .catch(error => console.error(error));
  }
}
